export default __webpack_public_path__ + "static/media/015-ecosystem.919a44e0.svg";